import { mockApiReturner } from "helpers/mockApiReturner";
import {
  AreaDataModel,
  ConditionDataModel,
  GenreDataModel,
  IAreaRequest,
  ScenarioDataModel,
} from "./models";

export const mockupApis = {
  getArea(req: number) {
    const response: AreaDataModel[] = [
      {
        label: "東京",
        value: "TOKYO",
        image: "images/areas/rsttop_area_search_tokyo.jpg",
        storeNum: 133419,
      },
      {
        label: "神奈川",
        value: "",
        image: "images/areas/rsttop_area_search_kanagawa.jpg",
        storeNum: 2000,
      },
      {
        label: "愛知",
        value: "",
        image: "images/areas/rsttop_area_search_aichi.jpg",
        storeNum: 2000,
      },
      {
        label: "大阪",
        value: "",
        image: "images/areas/rsttop_area_search_osaka.jpg",
        storeNum: 2000,
      },
      {
        label: "京都",
        value: "",
        image: "images/areas/rsttop_area_search_kyoto.jpg",
        storeNum: 2000,
      },
      {
        label: "福岡",
        value: "",
        image: "images/areas/rsttop_area_search_fukuoka.jpg",
        storeNum: 2000,
      },
    ];
    return mockApiReturner(response);
  },
  getDistricts(name: IAreaRequest) {
    // const response: AreaDataModel[] = [
    //   {
    //     label: "銀座",
    //     value: "",
    //     image: "",
    //     storeNum: 12,
    //   },
    //   {
    //     label: "有楽町",
    //     value: "",
    //     image: "",
    //     storeNum: 0,
    //   },
    //   {
    //     label: "新橋",
    //     value: "",
    //     image: "",
    //     storeNum: 0,
    //   },
    //   {
    //     label: "恵比寿",
    //     value: "",
    //     image: "",
    //     storeNum: 0,
    //   },
    //   {
    //     label: "六本木",
    //     value: "",
    //     image: "",
    //     storeNum: 0,
    //   },
    //   {
    //     label: "赤坂",
    //     value: "",
    //     image: "",
    //     storeNum: 0,
    //   },
    // ];
    const response: string[] = [
      "銀座",
      "有楽町",
      "新橋",
      "六本木",
      "赤坂",
    ];
    return mockApiReturner(response);
  },
  getKeyword(name: string) {
    const response = [
      "Ginza, Shinbashi, Yurakucho",
      "Tokyo/Nihonbashi",
      "Seibu line area",
      "Ikebukuro - Takadanobaba/Waseda",
      "Hamamatsucho, Tamachi, Shinagawa",
      "Izu Islands/Ogasawara",
    ];
    return mockApiReturner(response);
  },
  // getFoodGenre(name: string) {
  //   const response: GenreDataModel[] = [
  //     {
  //       name: "焼肉",
  //       imageUrl: "/images/genres/rsttop_condition_yakiniku_re1.jpg",
  //       storeNum: 29562,
  //       description:
  //         "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et",
  //     },
  //     {
  //       name: "寿司",
  //       imageUrl: "/images/genres/kodawari_index_4.jpg",
  //       storeNum: 32366,
  //     },
  //     {
  //       name: "居酒屋",
  //       imageUrl: "/images/genres/rsttop_condition_izakaya_re1.jpg",
  //       storeNum: 130555,
  //     },
  //     {
  //       name: "イタリアン",
  //       imageUrl: "/images/genres/rsttop_condition_italian_re1.jpg",
  //       storeNum: 34652,
  //     },
  //     {
  //       name: "イタリアン",
  //       imageUrl: "/images/genres/rsttop_condition_ramen_re1.jpg",
  //       storeNum: 52915,
  //     },
  //     {
  //       name: "カフェ",
  //       imageUrl: "/images/genres/rsttop_condition_cafe_re1.jpg",
  //       storeNum: 124569,
  //     },
  //     {
  //       name: "Pasta",
  //       imageUrl: "",
  //       storeNum: 124569,
  //     },
  //     {
  //       name: "Soba",
  //       imageUrl: "",
  //       storeNum: 124569,
  //     },
  //     {
  //       name: "French",
  //       imageUrl: "",
  //       storeNum: 4569,
  //     },
  //     {
  //       name: "Sushi",
  //       imageUrl: "",
  //       storeNum: 124569,
  //     },
  //     {
  //       name: "Italian",
  //       imageUrl: "",
  //       storeNum: 124569,
  //     },
  //   ];
  //   return mockApiReturner(response);
  // },
  // getScrenario(name: string) {
  //   const response: ScenarioDataModel[] = [
  //     {
  //       name: "お一人様",
  //       imageUrl: "/images/usages/scene_hitori_re1.png",
  //       storeNum: 133153,
  //     },
  //     {
  //       name: "家族・子供と",
  //       imageUrl: "/images/usages/scene_family_re1.png",
  //       storeNum: 180434,
  //     },
  //     {
  //       name: "接待",
  //       imageUrl: "/images/usages/scene_settai_re1.png",
  //       storeNum: 7334,
  //     },
  //     {
  //       name: "デート",
  //       imageUrl: "/images/usages/scene_date_re1.png",
  //       storeNum: 8667,
  //     },
  //     {
  //       name: "女子会",
  //       imageUrl: "/images/usages/scene_joshikai_re1.png",
  //       storeNum: 2512,
  //     },
  //     {
  //       name: "合コン",
  //       imageUrl: "/images/usages/scene_goukon_re1.png",
  //       storeNum: 323,
  //     },
  //   ];
  //   return mockApiReturner(response);
  // },
  // getCondition(name: string) {
  //   const response: ConditionDataModel[] = [
  //     {
  //       name: "個室",
  //       imageUrl: "/images/conditions/kodawari_index_4.jpg",
  //       storeNum: 243,
  //     },
  //     {
  //       name: "食べ放題",
  //       imageUrl: "/images/conditions/kodawari_index_1.jpg",
  //       storeNum: 243,
  //     },
  //     {
  //       name: "飲み放題",
  //       imageUrl: "/images/conditions/kodawari_index_3.jpg",
  //       storeNum: 243,
  //     },
  //     {
  //       name: "オシャレな空間",
  //       imageUrl: "/images/conditions/kodawari_index_2.jpg",
  //       storeNum: 243,
  //     },
  //     {
  //       name: "ネット予約可",
  //       imageUrl: "/images/conditions/kodawari_index_8.jpg",
  //       storeNum: 243,
  //     },
  //   ];
  //   return mockApiReturner(response);
  // },
};

export const mockKeyword = [
  "銀座・新橋・有楽町",
  "東京・日本橋",
  "渋谷・恵比寿",
  "新宿・代々木・大久保",
  "池袋～高田馬場",
  "原宿・表参道・青山",
  "上野・浅草・日暮里",
  "六本木・麻布・広尾",
  "赤坂・溜池",
  "品川・五反田・目黒",
  "お台場・豊洲・湾岸",
  "中目黒・三軒茶屋",
  "吉祥寺・三鷹",
  "下北沢・明大前",
  "吉祥寺・三鷹・武蔵境",
  "調布・府中・狛江",
  "立川・青梅",
  "町田・稲城・多摩",
  "国立・立川",
  "西東京市・国分寺",
  "麻布・広尾",
  "赤坂・永田町・溜池",
  "大井・蒲田",
  "小金井・国分寺・国立"
];